import { AfterViewInit, Component, inject, TemplateRef, ViewChild } from '@angular/core';

import { UiNotificationService } from '@core/services/ui-notification.service';

import { UiNotificationContentComponent } from './ui-notification-content.component';
import { UiNotificationConfig, UiNotificationTemplateData } from './ui-notification.types';

@Component({
  selector: 'ui-notification-host',
  standalone: true,
  imports: [UiNotificationContentComponent],
  template: `
    <ng-template #notificationTemplate let-data="data">
      <ui-notification-content [templateData]="data" />
    </ng-template>
  `,
})
export class UiNotificationHostComponent implements AfterViewInit {
  private readonly uiNotification = inject(UiNotificationService);

  @ViewChild('notificationTemplate', { static: true })
  private readonly notificationTemplate!: TemplateRef<{ data: UiNotificationTemplateData }>;

  ngAfterViewInit(): void {
    this.uiNotification.registerTemplate(this.notificationTemplate);
  }
}
